<template>
  <div class="shipmentdate _contract">
    <form v-on:submit.prevent="ButtonNext()">
      <div class="row m-0 navigation">
        <b-button-group class="row mx-0 px-4 navigation">
          <b-button @click="ButtonPrev">
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
            Back
          </b-button>
          <b-button type="submit">
            Next
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
          </b-button>
        </b-button-group>
      </div>

      <div>
        <h3 class="text-center shipmentdate__title">Select Your Shipment Duration and Route</h3>
        <div class="shipmentdate__container w-75">
          <p><b>Shipment Duration</b></p>
          <div class="shipmentdate__container--duration row m-0 mt-3">
            <div class="col-md-4 pl-0">
              <label class="w-100" for="duration-start">From</label>
              <b-form-datepicker placeholder="DD/MM/YYYY" v-model="data.duration_start"
                :date-format-options="{ month: '2-digit', day: '2-digit', year: 'numeric' }"
                :min="getDate(new Date())" name="date from"
                :state="errors.first('date from') && false"
                v-validate="'required'" locale="id" ></b-form-datepicker>
              <p v-if="errors.has('date from')" class="fontstyle__errormsg text-left">
                      {{ errors.first('date from') }}
              </p>
            </div>
            <div class="col-md-0 d-flex justify-content-center align-items-center p-0">
              -
            </div>
            <div class="col-md-4">
              <label class="w-100" for="duration-finish">To</label>
              <div class="">
                <b-form-datepicker placeholder="DD/MM/YYYY" v-model="data.duration_finish"
                  :date-format-options="{ month: '2-digit', day: '2-digit', year: 'numeric' }"
                  name="date to"
                  :min="getDate(data.duration_start)"
                  :state="errors.first('date to') && false"
                  v-validate="'required'" locale="id" ></b-form-datepicker>
                <p v-if="errors.has('date to')" class="fontstyle__errormsg text-left">
                  {{ errors.first('date to') }}
                </p>
              </div>
              <div class="row m-0 mt-2">
                <p class="col-md pl-0">Total Durations: </p>
                <p class="col-md pr-0 text-right" v-if="!data.duration_start || !data.duration_finish">0 Days</p>
                <p v-else class="col-md pr-0 text-right">{{getTotalDuration(data.duration_start, data.duration_finish)}} Days</p>
              </div>
              <div class="fontstyle__errormsg mt-1"
                    v-if="data.duration_start && data.duration_finish && !checkDuration(data.duration_start, data.duration_finish)">
                *Minimum contract duration 90 days, Maximum 365 days
              </div>
            </div>

            <div class="col-md pr-0 options__vselect">
              <label for="shipment-service">Shipment Service</label>
              <v-select
                id="shipment-service"
                v-model="shipmentService"
                :options="outputData.shipment_type === 'AIRCOURIER' ? shipmentServicelistCourir : shipmentServicelist"
                label="text"
                placeholder="Select Shipment Service"
                name="Shipment Service"
                v-validate="'required'"
                :state="errors.first('Shipment Service') && false"
              />
              <p v-if="errors.has('Shipment Service')" class="fontstyle__errormsg text-left">
                {{ errors.first('Shipment Service') }}
              </p>
            </div>
          </div>

          <p class="mt-3"><b>Destination</b></p>
          <div class="shipmentdate__container--destination row m-0 mt-3">
            <div class="col-md-6 pl-0 options__vselect">
              <label for="duration-start">Origin Country</label>
              <v-select
                v-model="originCountry"
                :options="countryList"
                label="name"
                placeholder="Origin Country"
                @input="chkInputLocation('originCountry')"
                name="Origin Country"
                v-validate="'required'"
                :state="errors.first('Origin Country') && false"
              />
              <p v-if="errors.has('Origin Country')" class="fontstyle__errormsg text-left">
                {{ errors.first('Origin Country') }}
              </p>
            </div>
            <div class="col-md-6 pr-0 options__vselect">
              <label for="duration-start">Destination Country</label>
              <v-select
                v-model="destinationCountry"
                :options="countryList"
                label="name"
                placeholder="Destination Country"
                @input="chkInputLocation('destinationCountry')"
                name="Destination Country"
                v-validate="'required'"
                :state="errors.first('Destination Country') && false"
              />
              <p v-if="errors.has('Destination Country')" class="fontstyle__errormsg text-left">
                {{ errors.first('Destination Country') }}
              </p>
            </div>
          </div>
          <div class="shipmentdate__container--destination row m-0 mt-3">
            <div class="col-md-6 pl-0 options__vselect">
              <label for="duration-start">Origin City</label>
              <v-select
                v-model="originCity"
                :options="cityList"
                label="name"
                :placeholder="isCityLoading ? 'Loading cities...' : 'Origin City'"
                @input="chkInputLocation('originCity')"
                name="Origin City"
                v-validate="'required'"
                :state="errors.first('Origin City') && false"
              />
              <p v-if="errors.has('Origin City')" class="fontstyle__errormsg text-left">
                {{ errors.first('Origin City') }}
              </p>
            </div>
            <div class="col-md-6 pr-0 options__vselect">
              <label for="duration-start">Destination City</label>
              <v-select
                v-model="destinationCity"
                :options="destinationCityList"
                label="name"
                :placeholder="isCityDestinationLoading ? 'Loading cities...' : 'Destination City'"
                @input="chkInputLocation('destinationCity')"
                name="Destination City"
                v-validate="'required'"
                :state="errors.first('Destination City') && false"
              />
              <p v-if="errors.has('Destination City')" class="fontstyle__errormsg text-left">
                {{ errors.first('Destination City') }}
              </p>
            </div>
          </div>
          <div class="shipmentdate__container--destination row m-0 mt-3">
            <div class="col-md-6 pl-0 ">
              <div v-if="pickUpOri">
                <label for="textarea1">Origin Pick Up Address</label>
                <b-form-textarea
                    id="textarea1"
                    placeholder="Type Your Pick Up Address"
                    rows="3"
                    max-rows="5"
                    v-model="data.delivery_address_ori"
                    name="Address"
                    v-validate="'required'"
                    :state="errors.first('Address') && false"
                  />
                  <p v-if="errors.has('Address')" class="fontstyle__errormsg text-left">
                    {{ errors.first('Address') }}
                  </p>
              </div>
            </div>
            <div class="col-md-6 pr-0 ">
              <div v-if="pickUpDes">
                <label for="textarea2">Destination Pick Up Address</label>
                <b-form-textarea
                  id="textarea2"
                  placeholder="Type Your Pick Up Address"
                  rows="3"
                  max-rows="5"
                  v-model="data.delivery_address_desti"
                  name="Address"
                  v-validate="'required'"
                  :state="errors.first('Address') && false"
                />
                <p v-if="errors.has('Address')" class="fontstyle__errormsg text-left">
                  {{ errors.first('Address') }}
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
      <!-- Modal Component -->
    <!-- <b-modal id="modal1" title="">
      <p class="my-4 text-center">
        After this page you will not be able to edit your shipment's
        detail informations. Do you want to continue to booking page ?
      </p>
    </b-modal> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import vSelect from 'vue-select'
import DatePick from 'vue-date-pick'
import fecha from 'fecha'

export default {
  name: 'shipment_date',
  components: {
    vSelect,
    DatePick
  },
  props: {
    showErrorShipmentDate: Boolean,
    outputData: Object
  },
  data () {
    return {
      shipmentService: { text: '', value: '', pickUpOri: false, pickUpDes: false },
      totalDuration: 0,
      statusDuration: true,
      data: {
        duration_start: moment().format('YYYY-MM-DD'),
        duration_finish: null,
        country_from: '',
        country_to: '',
        city_from: '',
        city_to: '',
        delivery_address_ori: '',
        delivery_address_desti: '',
        optiontp: ''
      },
      header: {
        id: 3,
        subtitle: ''
      },
      error: {},
      originCountry: '',
      destinationCountry: '',
      originCity: '',
      destinationCity: '',
      pickUpOri: false,
      pickUpDes: false,
      shipmentServicelist: [
        { text: 'Port to Port', value: 'ptp', pickUpOri: false, pickUpDes: false },
        { text: 'Port to Door', value: 'ptd', pickUpOri: false, pickUpDes: true },
        { text: 'Door to Port', value: 'dtp', pickUpOri: true, pickUpDes: false },
        { text: 'Door to Door', value: 'dtd', pickUpOri: true, pickUpDes: true }
      ],
      shipmentServicelistCourir: [
        { text: 'Door to Door', value: 'dtd', pickUpOri: true, pickUpDes: true }
      ]
    }
  },
  computed: {
    ...mapGetters({
      cityList: 'city/city',
      countryList: 'city/country',
      isCityLoading: 'city/isLoading',
      //
      destinationCityList: 'city/destinationCities',
      isCityDestinationLoading: 'city/isLoadingDestination'
    }),

    start () {
      return this.data.duration_start
    },
    end () {
      return this.data.duration_finish
    },
    delivery_address_ori () {
      return this.data.delivery_address_ori
    },
    delivery_address_desti () {
      return this.data.delivery_address_desti
    },
    oCountry () {
      return this.data.country_from
    },
    dCountry () {
      return this.data.country_to
    },
    city_from () {
      return this.data.city_from
    },
    city_to () {
      return this.data.city_to
    }

  },
  mounted () {
    this.fetchCountry()
  },
  watch: {
    start (data) {
      if (data) {
        this.pushTextToHeader(moment(this.data.duration_start).format('DD-MM-YYYY'),
          moment(this.data.duration_finish).format('DD-MM-YYYY'),
          this.data.country_from, this.data.country_to)
      }
    },
    end (data) {
      if (data) {
        this.pushTextToHeader(moment(this.data.duration_start).format('DD-MM-YYYY'),
          moment(this.data.duration_finish).format('DD-MM-YYYY'),
          this.data.country_from, this.data.country_to)
      }
    },
    oCountry (data) {
      if (data) {
        this.pushTextToHeader(moment(this.data.duration_start).format('DD-MM-YYYY'),
          moment(this.data.duration_finish).format('DD-MM-YYYY'),
          this.data.country_from, this.data.country_to)
      }
    },
    dCountry (data) {
      if (data) {
        this.pushTextToHeader(moment(this.data.duration_start).format('DD-MM-YYYY'),
          moment(this.data.duration_finish).format('DD-MM-YYYY'),
          this.data.country_from, this.data.country_to)
      }
    },
    shipmentService (data) {
      if (data.value !== null) {
        this.data.optiontp = data.value
        this.shipmentService = data
      }
      if (this.outputData.shipment_type && this.outputData.shipment_type === 'AIRCOURIER') {
        this.showPickUpAddress()
      }
      this.pushData()
      this.filterShowPickUpAddress(this.data.optiontp)
    },
    originCountry (data) {
      if (data) {
        this.checkingErrorRoute('originCountry', data)
      }
    },
    destinationCountry (data) {
      if (data) {
        this.checkingErrorRoute('desCountry', data)
      }
    },
    originCity (data) {
      if (data) {
        this.checkingErrorRoute('originCity', data)
      }
    },
    destinationCity (data) {
      if (data) {
        this.checkingErrorRoute('destinationCity', data)
      }
    },
    delivery_address_ori (data) {
      if (data) {
        this.checkingErrorRoute('addressOri', data)
      }
    },
    delivery_address_desti (data) {
      if (data) {
        this.checkingErrorRoute('addressDes', data)
      }
    }
  },
  methods: {
    async fetchCountry () {
      await this.$store.dispatch('city/FETCH_COUNTRIES')
    },
    async fetchCity (data) {
      this.$store.dispatch('city/FETCH_CITIES', data.code)
    },
    async fetchCityDestination (data) {
      this.$store.dispatch('city/FETCH_CITIES_DESTINATION', data.code)
    },

    pushData () {
      this.$emit('chgHeader', this.header)
      this.$emit('inputData', this.data)
    },

    pushTextToHeader (dateFrom, dateTo, countryFrom, countryTo) {
      let duration = ''
      let destination = ''
      if (dateFrom || dateTo) {
        duration = dateFrom + ' to ' + dateTo
      }
      if (countryFrom || countryTo) {
        destination = ', ' + countryFrom + ' - ' + countryTo
      }
      this.header.subtitle = duration + destination
      this.pushData()
    },
    checkDuration (from, to) {
      let status = true
      const different = this.getTotalDuration(from, to)
      if (different < 90 || different > 365) {
        status = false
      }
      return status
    },

    getTotalDuration (from, to) {
      const dateDefauld = 'YYYY/MM/DD'
      const dateFrom = moment([moment(from, dateDefauld).year(), moment(from, dateDefauld).month(), moment(from, dateDefauld).date()])
      const dateTo = moment([moment(to, dateDefauld).year(), moment(to, dateDefauld).month(), moment(to, dateDefauld).date()])
      const different = dateTo.diff(dateFrom, 'days')
      return different
    },

    showPickUpAddress () {
      this.shipmentService = 'Door to Door'
      this.data.optiontp = 'dtd'
    },
    filterShowPickUpAddress (shipmentService) {
      this.shipmentServicelist.filter((inputaddress) => {
        if (inputaddress.value === shipmentService) {
          this.pickUpOri = inputaddress.pickUpOri
          this.pickUpDes = inputaddress.pickUpDes
        }
      })
    },
    chkInputLocation (type) {
      // checking type
      const data = this.data
      if (type === 'originCountry') {
        data.country_from = this.originCountry ? this.originCountry.code : ''
        data.city_from = ''
        this.originCity = ''
      } else if (type === 'destinationCountry') {
        data.country_to = this.destinationCountry ? this.destinationCountry.code : ''
        data.city_to = ''
        this.destinationCity = ''
      } else if (type === 'originCity') {
        data.city_from = this.originCity ? this.originCity.code : ''
      } else {
        // type => destinationCity
        data.city_to = this.destinationCity ? this.destinationCity.code : ''
      }

      // checking destination is exist
      if (data.country_from && data.country_to) {
        this.pushTextToHeader(moment(data.duration_start).format('DD-MM-YYYY'),
          moment(data.duration_finish).format('DD-MM-YYYY'),
          data.country_from, data.country_to)
      }
      this.pushData()
    },
    checkingErrorRoute (name, data) {
      if (name === 'originCountry') {
        this.error.originCountry = !data
        this.fetchCity(data)
      } else if (name === 'desCountry') {
        this.error.destinationCountry = !data
        this.fetchCityDestination(data)
      } else if (name === 'originCity') {
        this.error.originCity = !data
        this.data.city_from = data && data.code ? data.code : ''
      } else if (name === 'destinationCity') {
        this.error.destinationCity = !data
        this.data.city_to = data && data.code ? data.code : ''
      } else if (name === 'addressOri') {
        this.error.pickUpAddress = !data
      } else if (name === 'addressDes') {
        this.error.deliveryAddress = !data
      }
      this.$emit('inputData', this.data)
    },
    isPastDate (date) {
      var yesterday = new Date(Date.now() - 864e5)
      return date < yesterday
    },
    parseDate (dateString, format) {
      return fecha.parse(dateString, format)
    },
    formatDate (dateObj, format) {
      return fecha.format(dateObj, format)
    },

    getDate (date) {
      let newDate = ''
      if (date) {
        newDate = moment(date).format('YYYY-MM-DD')
      }
      return newDate
    },

    ButtonNext () {
      this.$validator.validateAll().then((result) => {
        if (result && this.checkDuration(this.data.duration_start, this.data.duration_finish)) {
          this.$emit('tabIndex')
          this.$emit('inputData', this.data)
        } else {
          console.log('error required')
        }
      })
    },
    ButtonPrev () {
      this.$emit('tabIndexPrev')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/ShipmentDate.vue